import React from 'react';
import { Navigate } from 'react-router-dom';

import { organizationSettingsRoutes } from './pages-settings/routes';
import RouteDataLayout from './routes/RouteDataLayout';
import RouteGuardLayout from './routes/RouteGuardLayout';

import type { RouteObject } from 'react-router-dom';

const GeneralStep = React.lazy(() => import('./pages/General'));
const UsersStep = React.lazy(() => import('./pages/Users'));
const SummaryStep = React.lazy(() => import('./pages/Summary'));

function suspense(el: React.ReactNode) {
	return <React.Suspense fallback={null}>{el}</React.Suspense>;
}

const createWizardRoutes = (index: string) => {
	return [
		{ index: true, element: <Navigate to={index} replace /> },
		{ path: 'general', element: suspense(<GeneralStep />) },
		{ path: 'users', element: suspense(<UsersStep />) },
		{ path: 'summary', element: suspense(<SummaryStep />) },
		organizationSettingsRoutes,
	];
};

export const organizationCreateRoutes: RouteObject[] = [
	{
		element: <RouteGuardLayout />,
		children: [
			{
				element: <RouteDataLayout />,
				children: createWizardRoutes('general'),
			},
		],
	},
];

export const organizationEditRoutes: RouteObject[] = [
	{
		element: <RouteDataLayout />,
		children: createWizardRoutes('summary'),
	},
];
